<!-- Body Container -->
<div class="h-screen overflow-y-auto surface-100 text-sm pb-6 md:mb-0">
  <!-- Header -->
  <ff-paylink-header [showTimeline]="false"></ff-paylink-header>
  <!-- Header -->

  <!-- Content -->
  @if (errCode() === "") {
    <div
      class="w-12 md:w-7 xl:w-5 mx-auto p-3 md:px-0 pb-8 md:pb-0 mb-6 md:mb-0"
    >
      <h2 class="p-error text-7xl my-6 text-center">
        <img src="/assets/img/oops-text.svg" alt="Oops" />
      </h2>
      <div class="text-center my-6">
        <img src="/assets/img/expired-link-img.svg" alt="Link Expired Image" />
      </div>

      <div class="text-center mt-6">
        <h3 class="text-xl md:text-3xl mb-2">
          {{ "PAYLINK_APP.NOT_FOUND.LINK_EXPIRE" | translate }}
        </h3>
        <p class="text-sm">
          {{ "PAYLINK_APP.NOT_FOUND.TRY_AGAIN" | translate }}
        </p>
      </div>
    </div>
  }

  @if (errCode() === "signuplinkexpire") {
    <div
      class="w-12 md:w-7 xl:w-5 mx-auto p-3 md:px-0 pb-8 md:pb-0 mb-6 md:mb-0"
    >
      <h2 class="p-error text-7xl my-6 text-center">
        <img src="/assets/img/oops-text.svg" alt="Oops" />
      </h2>
      <div class="text-center my-6">
        <img src="/assets/img/expired-link-img.svg" alt="Link Expired Image" />
      </div>

      <div class="text-center mt-6">
        <h3 class="text-xl md:text-3xl mb-2">
          {{ "PAYLINK_APP.NOT_FOUND.LINK_EXPIRE" | translate }}
        </h3>
        <p class="text-sm">
          {{ "PAYLINK_APP.NOT_FOUND.TRY_AGAIN" | translate }}
        </p>
      </div>
    </div>
  }

  @if (errCode() === "awaitingpayment") {
    <div
      class="w-12 md:w-7 xl:w-5 mx-auto p-3 md:px-0 pb-8 md:pb-0 mb-6 md:mb-0"
    >
      <h2 class="text-7xl my-6 text-center">
        <img
          src="/assets/img/awaiting-payment-text.svg"
          alt="{{ 'PAYLINK_APP.NOT_FOUND.AWITING_PAYMENT' | translate }}"
        />
      </h2>
      <div class="text-center my-6">
        <img src="/assets/img/bank-payment-img.svg" alt="Bank Payment Image" />
      </div>

      <div class="text-center mt-6">
        <h3 class="text-2xl md:text-3xl mb-0">
          {{ "PAYLINK_APP.NOT_FOUND.BANK_WAITING" | translate }}
        </h3>
      </div>
    </div>
  }

  @if (errCode() === "subscriptioncreated") {
    <div class="w-12 md:w-7 xl:w-5 mx-auto p-3 md:px-0 mb-8 relative">
      <img
        class="block mx-auto my-6"
        src="/assets/img/yay-text.svg"
        alt="Yay!"
      />
      <div class="text-center my-6">
        <img src="/assets/img/thank-you-img.svg" alt="Image" />
      </div>

      <div class="text-center mt-6">
        <h3 class="text-xl md:text-3xl mb-2">
          {{ "PAYLINK_APP.NOT_FOUND.SUBSCRIPTION_CREATED" | translate }}
        </h3>
      </div>
    </div>
  }

  @if (errCode() === "transferinitiate") {
    <div class="w-12 md:w-7 xl:w-5 mx-auto p-3 md:px-0 mb-8 relative">
      <img
        class="block mx-auto my-6"
        src="/assets/img/yay-text.svg"
        alt="Yay!"
      />
      <div class="text-center my-6">
        <img src="/assets/img/thank-you-img.svg" alt="Image" />
      </div>

      <div class="text-center mt-6">
        <h3 class="text-xl md:text-3xl mb-2">
          {{ "PAYLINK_APP.NOT_FOUND.TRANSFER_INITIATE" | translate }}
        </h3>
        <p class="text-lg text-gray-700">
          {{ "PAYLINK_APP.NOT_FOUND.TRANSFER_INITIATE_INFO" | translate }}
        </p>
      </div>
    </div>
  }

  @if (errCode() === "notfound") {
    <div
      class="w-12 md:w-7 xl:w-5 mx-auto p-3 md:px-0 pb-8 md:pb-0 mb-6 md:mb-0"
    >
      <h2 class="p-error text-7xl my-6 text-center">
        <img src="/assets/img/oops-text.svg" alt="Oops" />
      </h2>
      <div class="text-center my-6">
        <img src="/assets/img/expired-link-img.svg" alt="Link Expired Image" />
      </div>

      <div class="text-center mt-6">
        <h3 class="text-xl md:text-3xl mb-2">
          {{ "PAYLINK_APP.NOT_FOUND.SUBSCRIPTION_NOT_FOUND" | translate }}
        </h3>
        <p class="text-lg text-gray-700">
          {{ "PAYLINK_APP.NOT_FOUND.TRY_AGAIN" | translate }}
        </p>
      </div>
    </div>
  }

  @if (errCode() === "companynotfound") {
    <div
      class="w-12 md:w-7 xl:w-5 mx-auto p-3 md:px-0 pb-8 md:pb-0 mb-6 md:mb-0"
    >
      <h2 class="p-error text-7xl my-6 text-center">
        <img src="/assets/img/oops-text.svg" alt="Oops" />
      </h2>
      <div class="text-center my-6">
        <img src="/assets/img/expired-link-img.svg" alt="Link Expired Image" />
      </div>

      <div class="text-center mt-6">
        <h3 class="text-xl md:text-3xl mb-2">Company not Found</h3>
        <p class="text-lg text-gray-700">Company not found</p>
      </div>
    </div>
  }
  <!-- Content -->
</div>
<!-- Body Container -->
